import React from 'react';
import Warning from '../assets/images/Warning.svg';

export default () => {
  return <img src={Warning} alt="warning" />;
};
